import { render } from "./EditInfoDayService.vue?vue&type=template&id=4ece2513&scoped=true"
import script from "./EditInfoDayService.vue?vue&type=script&lang=js"
export * from "./EditInfoDayService.vue?vue&type=script&lang=js"

import "./EditInfoDayService.vue?vue&type=style&index=0&id=4ece2513&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ece2513"]])

export default __exports__